import React from 'react';
import { Box, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

const commonStyles = {
  bgcolor: 'background.paper',
  borderColor: '#9B9B9B',
  m: 1,
  border: 1,
  width: '21px',
  height: '21px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const SelectableBoxCommon = ({ selectedValue, value, onClick, text, showIcon }: any) => {
  return (
    <Box
      display={"flex"}
      gap={2}
      alignItems={"center"}
      position={"relative"}
      sx={{ cursor: 'pointer' }}
      onClick={() => onClick(value)}
    >
      {selectedValue === value && (
        <Box sx={{ borderLeft: "9px solid #233F91", height: "29px", position: "absolute", left: "-15px" }}></Box>

      )}
      <Box display={"flex"} gap={1} alignItems={"center"}>
        <Box sx={{ ...commonStyles, borderRadius: '50%', color: "#9B9B9B" }}>
          {showIcon && <DoneIcon sx={{ color: '#233F91', fontSize: '16px' }} />}
        </Box>
        <Typography
          sx={{
            fontSize: '17px',
            fontWeight: selectedValue === value ? 500 : 400,
            color: selectedValue === value ? '#233F91' : '#595959',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default SelectableBoxCommon;
